import { PlayerModel } from "../Models/PlayerModel";

export class Debug {
    private static _cache = [];
    public static drawAABB(parent, model) {
        return; //comment for debug
        const aabb = model.aabb;
        let graphics;
        for (let index = 0; index < Debug._cache.length; index++) {
            if (Debug._cache[index].parent === parent) {
                graphics = Debug._cache[index].graphics;
                graphics.clear();
                break;
            }
        }
        if (!graphics) {
            graphics = new PIXI.Graphics();
            this._cache.push({ parent, graphics });
        }
        graphics.lineStyle(2, 0xff0000, 1);
        graphics.beginFill(0xff00ff, 0.2);
        // console.log('draw', aabb[2], aabb[3], parent.scaleX);

        if (model instanceof PlayerModel) {
            // graphics.drawEllipse(aabb[0] - model.pos[0] + 0.5 * aabb[2], aabb[1] - model.pos[1] + 0.5 * aabb[3], 0.5 * aabb[2] / parent.scaleX, 0.5 * aabb[3]);
            const aabbComposite = model.aabbComposite;
            for (let index = 0; index < aabbComposite.length; index++) {
                const aabb = aabbComposite[index];
                graphics.drawRect(aabb.min.x - model.pos.x, aabb.min.y - model.pos.y, aabb.max.x - aabb.min.x, aabb.max.y - aabb.min.y);
            }
        } else {
            graphics.drawRect(aabb.min.x - model.pos.x, aabb.min.y - model.pos.y, aabb.max.x - aabb.min.x, aabb.max.y - aabb.min.y);
        }
        graphics.endFill();
        parent.display.addChild(graphics);
    }
}